import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { getTimeFromUTCToTimezone } from 'shared/utils/getTimeFromUTCToTimezone';

dayjs.extend(customParseFormat);
export class AgentAdminConverter {
  convertFeedbackLink(data) {
    return {
      link: data.link,
      isVisible: data.is_visible,
    };
  }
  convertNotifications(data) {
    return data
      .map(item => {
        return {
          id: item.id,
          date: item.created_at
            ? getTimeFromUTCToTimezone(dayjs(item.created_at, 'YYYY-MM-DDTHH:mm:ss.ssssss')).format(
                'DD.MM.YYYY HH:mm:ss',
              )
            : null,
          type: item?.type,
          amount: item?.amount,
          fromId: item?.from_id,
          currency: item?.currency,
          notification: item.notification,
        };
      })
      .sort(
        (a, b) =>
          dayjs(b.date, 'DD.MM.YYYY HH:mm:ss').toDate().valueOf() -
          dayjs(a.date, 'DD.MM.YYYY HH:mm:ss').toDate().valueOf(),
      )
      .valueOf();
  }

  convertRankings(data) {
    const agentsRanking = Object.keys(data?.agent_ranking || {})
      .map(id => {
        const item = data?.agent_ranking[id];

        return {
          id: item.id,
          username: item.username,
          points: item.rank_points,
          rank: item.rank,
        };
      })
      .sort((a, b) => (a.points > b.points ? -1 : a.points < b.points ? 1 : 0));

    return {
      agentsRanking,
      myRank: {
        position: data?.my_rang && data?.my_rang.position,
        rank: data?.my_rang && data?.my_rang.rank,
      },
      withRanking: Boolean(data?.rank_level),
    };
  }

  convertBetsLimits(data) {
    return {
      digsport: data.sport_bet_limit,
      slots: data.slots_bet_limit,
      liveCasino: data.live_casino_bet_limit,
    };
  }

  convertDomains(data) {
    return {
      domainRequests: data.domain_requests.map(item => {
        return {
          domainName: item.domain_name,
          createdAt: dayjs(item.created_at).format('HH:mm DD.MM.YYYY'),
          comment: item.comment,
          status: item.status,
        };
      }),
      // agentDomains: data.agent_domains.map(item => {
      //   return {
      //     domainName: item.domain_name,
      //     createdAt: dayjs(item.created_at).format('HH:mm DD.MM.YYYY'),
      //   };
      // }),
    };
  }

  convertMyDomains(data) {
    return {
      // domainRequests: data.domain_requests.map(item => {
      //   return {
      //     domainName: item.domain_name,
      //     createdAt: dayjs(item.created_at).format('HH:mm DD.MM.YYYY'),
      //     comment: item.comment,
      //     status: item.status,
      //   };
      // }),
      agentDomains: data.agent_domains.map(item => {
        return {
          domainName: item.domain_name,
          createdAt: dayjs(item.created_at).format('HH:mm DD.MM.YYYY'),
        };
      }),
      totalCount: data.total_count,
    };
  }

  convertRevshareDepositPreorder(data) {
    return {
      id: data.id,
      preorderAmount: data.preorder_amount,
      confirmedAmount: data.confirmed_amount,
      walletAddress: data.wallet_address,
      walletQrCodeUrl: data.wallet_qr_code_url,
      currency: data.currency,
      network: data.network,
      status: data.status,
      expiresAt: data.expires_at,
    };
  }

  convertRevshareDeposit(data) {
    return {
      id: data.id,
      agentId: data.agent_id,
      preorderAmount: data.preorder_amount,
      confirmedAmount: data.confirmed_amount,
      walletAddress: data.wallet_address,
      currency: data.currency,
      network: data.network,
      status: data.status,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  }
}
